/**
 * @file 로그인 세션 공통 처리
 * @description SessionGuard: 앱 전체에 한번. 재로그인 모달, 미사용 경고 (응답 도메인 제외)
 *              AuthGate: 로그인 필요한 화면. 로그인 정보가 없는데 이 브라우저에서 로그인 중이었으면 모달만 띄운다
 */
import { ReactNode, useEffect, useSyncExternalStore } from 'react'
import { getHasMe, subscribeMe, getRelogin, openRelogin, isRespondHost, isTopWindow } from 'ts-utils/session'
import ReLoginModal from './ReLoginModal'
import IdleWatcher, { useActivityTracker } from './IdleWatcher'

export function SessionGuard() {
    useActivityTracker()

    if (isRespondHost() || !isTopWindow()) return null

    return (
        <>
            <IdleWatcher/>
            <ReLoginModal/>
        </>
    )
}

export function AuthGate(props: { children: ReactNode }) {
    const { children } = props

    // 로그인 여부만 구독 (정보가 바뀌어도 화면은 그대로)
    const hasMe = useSyncExternalStore(subscribeMe, getHasMe)

    useEffect(() => {
        if (hasMe) return

        // 앱 시작때 로그인이 풀린걸 알았으면 (만료, 업데이트 전 토큰 등) 재로그인 모달
        const { reason, expectUserNo } = getRelogin()
        if (expectUserNo) openRelogin(reason, expectUserNo)
    }, [hasMe])

    // 로그인 정보 없이 화면을 그리면 화면마다 오류가 나므로, 로그인 될때까지는 모달만
    if (!hasMe) return null

    return <>{children}</>
}
